import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="pt-32 pb-20 px-6 lg:px-8 max-w-4xl mx-auto text-center" data-id="element-107">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} data-id="element-108">
        <span className="text-amber font-bold tracking-widest uppercase text-sm mb-6 block" data-id="element-109">
          Digital Master Guide
        </span>
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-8" data-id="element-110">
          Nutri-Sync Protocol: The End of Functional Exhaustion and Cellular
          Hunger
        </h1>
        <h2 className="text-xl md:text-2xl text-charcoal/80 font-serif italic mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-111">
          How to close the nutritional gaps coffee can't hide and restore your
          biological energy in 21 days.
        </h2>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-forest/10 text-left" data-id="element-112">
        <p className="text-lg md:text-xl leading-relaxed text-charcoal mb-6" data-id="element-113">
          You wake up after 8 hours of sleep and still feel like a truck ran
          over you. By 3:00 PM, your brain simply "shuts off," leaving you stuck
          in a mental fog that no amount of coffee can clear.
        </p>
        <p className="text-lg md:text-xl leading-relaxed text-charcoal" data-id="element-114">
          It's not a lack of willpower. It's not just that you're getting older.
          It's something much deeper:{' '}
          <strong className="text-forest" data-id="element-115">
            your cells are crying out for the micronutrients that stress and
            modern life have stolen from them.
          </strong>
        </p>
      </motion.div>
    </section>;
}